import { render, staticRenderFns } from "./UploadArquivoTerritorioGlebaOperacao.vue?vue&type=template&id=955897a0&lang=pug"
import script from "./UploadArquivoTerritorioGlebaOperacao.vue?vue&type=script&lang=js"
export * from "./UploadArquivoTerritorioGlebaOperacao.vue?vue&type=script&lang=js"
import style0 from "./UploadArquivoTerritorioGlebaOperacao.vue?vue&type=style&index=0&id=955897a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports